import { render, staticRenderFns } from "./CodeBind.vue?vue&type=template&id=540f0388&scoped=true&"
import script from "./CodeBind.vue?vue&type=script&lang=js&"
export * from "./CodeBind.vue?vue&type=script&lang=js&"
import style0 from "./CodeBind.vue?vue&type=style&index=0&id=540f0388&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540f0388",
  null
  
)

export default component.exports